import axiosInstance from "../../config/axios-instance";

const getAllUserFolders = () => {
  let token = localStorage.getItem("token");
  return axiosInstance({
    method: "get",
    url: "/user-folders",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const getOneUserFolder = (id: any) => {
  let token = localStorage.getItem("token");
  const config: any = {
    method: "get",
    url: `/user-folders/${id}`,
  };
  if (token) {
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
  }
  return axiosInstance(config);
};

const getOneUserFolderPublic = (id: any) => {
  return axiosInstance({
    method: "get",
    url: `/user-folders/showClient/${id}`,
  });
};

const createUserFolder = (data: any) => {
  let token = localStorage.getItem("token");
  return axiosInstance({
    method: "post",
    url: `/user-folders`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const updateUserFolder = (id: any, data: any) => {
  let token = localStorage.getItem("token");
  return axiosInstance({
    method: "put",
    url: `/user-folders/${id}`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const deleteUserFolder = (id: any) => {
  let token = localStorage.getItem("token");
  return axiosInstance({
    method: "delete",
    url: `/user-folders/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const attachProductToFolder = (folderId: any, productId: any) => {
  let token = localStorage.getItem("token");
  return axiosInstance({
    method: "post",
    url: "/user-folders/attach-product",
    data: {
      folder_id: folderId,
      product_id: productId,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const detachProductFromFolder = (folderId: any, productId: any) => {
  let token = localStorage.getItem("token");
  return axiosInstance({
    method: "post",
    url: "/user-folders/detach-product",
    data: {
      folder_id: folderId,
      product_id: productId,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const UserFoldersServices = {
  getAllUserFolders,
  getOneUserFolder,
  createUserFolder,
  updateUserFolder,
  deleteUserFolder,
  attachProductToFolder,
  detachProductFromFolder,
  getOneUserFolderPublic,
};

export default UserFoldersServices;
